import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import {
  TCreatePermissionReqData,
  TCreatePermissionResData,
  TDeletePermissionResData,
  TGetPermissionsListParams,
  TGetPermissionsListResData,
  TUpdatePermissionReqData,
  TUpdatePermissionResData,
} from '../types/permissions.types';

export const getPermissionsListService = async (
  params: TGetPermissionsListParams): Promise<TGetPermissionsListResData> => {
  const config = { params };
  const url = API_ENDPOINTS.KETO_PERMISSIONS.PERMISSIONS;
  const res = await apiClient.get<TGetPermissionsListResData>(url, config);

  return res.data;
};

export const createPermissionService = async (reqData: TCreatePermissionReqData): Promise<TCreatePermissionResData> => {
  const url = API_ENDPOINTS.KETO_PERMISSIONS.PERMISSIONS;
  const res = await apiClient.post<TCreatePermissionResData>(url, reqData);

  return res.data;
};

export const updatePermissionService = async (
  permissionGuid: string,
  reqData: TUpdatePermissionReqData
): Promise<TUpdatePermissionResData> => {
  const url = API_ENDPOINTS.KETO_PERMISSIONS.PERMISSION.replace(EApiPathParams.PermissionGuid, permissionGuid);
  const res = await apiClient.put<TUpdatePermissionResData>(url, reqData);

  return res.data;
};

export const deletePermissionService = async (permissionGuid: string): Promise<TDeletePermissionResData> => {
  const url = API_ENDPOINTS.KETO_PERMISSIONS.PERMISSION.replace(EApiPathParams.PermissionGuid, permissionGuid);
  const res = await apiClient.delete<TDeletePermissionResData>(url);

  return res.data;
};
